<div *ngIf="shownView === View.LOGIN">
    <ols-login-form
        [isShowingConfirmationBubble]="isShowingConfirmationBubble"
        (viewChange)="changeShownView($event)"
    ></ols-login-form>
</div>

<div *ngIf="shownView === View.SIGN_UP">
    <ols-sign-up (viewChange)="changeShownView($event)"></ols-sign-up>
</div>

<div *ngIf="shownView === View.RESET_PASSWORD">
    <ols-reset-password
        (viewChange)="changeShownView($event)"
        (messageSent)="passwordResetSent()"
    ></ols-reset-password>
</div>
